import { CANDIDATE_TEST_EVENTS } from '../../constants/events';

import { copyObject } from '../../utils';

let defaultState = {
  isContextLoaded: false,
  currentSurveyQuestion: 1,
  currentSkillTestQuestion: 1,
  surveyQuestions: [],
  surveyAnswers: {},
  skillTestQuestions: [],
  skillTestAnswers: {},
  currentTab: 'survey',
  feedbackQuestions: [],
  feedbackAnswers: {},
  surveyQuestionsOverall: [],
  surveyConfidenceQuestionMap: {},
  isTestSubmitted: false,
  isTestStarted: false,
  testResponse: {},
  testResponseStep: 1,
  specialQuestionIds: {},
  url: '',
  redirectURL: '',
  finalFeedbackQuestion: {},
  finalFeedbackAnswer: {},
  message: ''
};

const CandidateTestReducer = (state = defaultState, actions) => {
  let newState = state;
  let currentState;

  switch (actions.type) {
    case CANDIDATE_TEST_EVENTS.SHOW_NEXT_SURVEY_QUESTION:
      currentState = copyObject(state);
      currentState.currentSurveyQuestion++;
      newState = currentState;
      break;
    case CANDIDATE_TEST_EVENTS.SHOW_PREVIOUS_SURVEY_QUESTION:
      currentState = copyObject(state);
      currentState.currentSurveyQuestion--;
      newState = currentState;
      break;
    case CANDIDATE_TEST_EVENTS.INITIALIZE_CONTEXT:
    case CANDIDATE_TEST_EVENTS.UPDATE_CONTEXT:
    case CANDIDATE_TEST_EVENTS.CHANGE_TAB:
    case CANDIDATE_TEST_EVENTS.SHOW_RESPONSE:
    case CANDIDATE_TEST_EVENTS.SET_FINAL_FEEDBACK_ANSWER:
    case CANDIDATE_TEST_EVENTS.SET_REDIRECT_URL:
    case CANDIDATE_TEST_EVENTS.SET_ERROR:
      newState = Object.assign({}, copyObject(state), actions.payload);
      break;
    case CANDIDATE_TEST_EVENTS.START_TEST:
      newState = Object.assign({}, state, { isTestStarted: true });
      break;
    case CANDIDATE_TEST_EVENTS.SHOW_NEXT_RESPONSE_SCREEN:
      currentState = copyObject(state);
      currentState.testResponseStep++;
      newState = currentState;
      break;
  }

  return newState;
};

export default CandidateTestReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/CandidateTestReducer/index.js